<template>
  <div>
    <!-- 活动进行中 -->
    <div id="activity" v-if="activityResStatus.status === 0 && activityInfo" :style="{'background-color': activityInfo.activity_color || '#14168a'}">

      <!-- 绑定背景图片 -->
      <!-- <div class="activity-banner" :style="{'background-image': 'url(' + activityInfo.activity_img + ')'}"></div> -->
      <img class="activity-banner" :src="activityInfo.activity_img" width="100%" />

      <div class="province-box">
        <div class="container">

          <div class="province-title">
            <span class="location-address-icon"></span>
            常住地 - {{provinceMap[formInfo.provinceCode]}}
          </div>

          <div class="province-content" :class="{'noauto-height': !uiSwitch.isExpand}">
            <div 
              class="province-item" 
              :class="{'chosen': key == formInfo.provinceCode}"
              v-for="(pro, key) in provinceMap" 
              :key="key" 
              @click="chooseProvince(+key)">
                {{pro}}
            </div>
          </div>

          <div class="province-button" @click="toggleProvince">

            <span>{{uiSwitch.isExpand ? '收起' : '更多'}}</span>
            <i class="el-icon-arrow-down" :class="{'arrow-reverse': uiSwitch.isExpand}"></i>
          </div>

        </div>
      </div>

      <div class="product-box" v-if="activityInfo.activity_product && activityInfo.activity_product.length > 0">
        <activity-product-list :product-list="activityInfo.activity_product" :provinceCode="formInfo.provinceCode" :activityInfo="activityInfo"></activity-product-list>
      </div>

      <div class="no-product" v-else>
        <img src="../../assets/imgs/noproduct.png">
      </div>

    </div>

    <!-- 活动已结束 -->
    <div id="promptClose" v-if="activityResStatus.status === 1">
      <img class="activityCloseImg" src="../../assets/imgs/activityClose.png" alt="activityClose">
      <h1 class="title">哎呀，活动结束了！</h1>
      <p class="content">上上签会定期推出优惠活动，敬请关注！</p>
    </div>

    <!-- 活动未开始 -->
    <div id="promptNot" v-if="activityResStatus.status === 2">
      <img class="activityNotImg" src="../../assets/imgs/activityNot.png" alt="activityNot">
      <h1 class="title">活动即将开始！</h1>
      <p class="content">{{activityResStatus.message}}</p>
    </div>

  </div>

</template>


<script>
import sensorsdata from 'sa-sdk-javascript';
import User from '../../libs/user';
import province from '../../libs/province';
import utils from '../../libs/utils';
import Http from '../../libs/http';
import ActivityProductList from './components/activity-product-list.vue';

export default {
  name: 'activity',
  components: {
    ActivityProductList,
  },
  data() {
    return {
      User,
      queryParams: {
        activityId: this.$route.query.id ? +this.$route.query.id : undefined,
      },
      uiSwitch: {
        isExpand: false,
      },
      formInfo: {
        provinceCode: 0,
      },
      activityInfo: {},
      activityResStatus: {
        status: 0,
        message: '',
      },

    };
  },
  created() {
    this.queryData(true);

    User.loaded.then(() => {
      sensorsdata.track('SalesPromotionView', {
        peer_name: User.peer.peer_name,
        visa_peer_id: User.peer.visa_peer_id,
      });
    });
  },
  computed: {
    provinceMap() {
      return utils.extend({ 0: '全部' }, province);
    },
  },
  methods: {
    async queryData(isFirst) {
      try {
        if (!this.queryParams.activityId) return;
        const res = await Http.post('/sys/visa_activity', { 
          visa_activity_id: this.queryParams.activityId, 
          channel: 2, 
          province_code: isFirst ? undefined : this.formInfo.provinceCode, 
          peer_account_id: this.User.peer_account_id, 
        });
        this.activityInfo = res;
        this.activityResStatus.status = 0;
        // 首次需要赋予初始值
        if (isFirst) {
          this.formInfo.provinceCode = res.province_code;
        }

      } catch (e) {
        if (e.ret === -2) {
          this.activityResStatus.message = e.msg;
          this.activityResStatus.status = 2;
        } else if (e.ret === -1) {
          this.activityResStatus.message = e.msg;
          this.activityResStatus.status = 1;
        }
      }
    },
    toggleProvince() {
      if (this.uiSwitch.isExpand) {
        this.uiSwitch.isExpand = false;
      } else {
        this.uiSwitch.isExpand = true;
      }
    },
    chooseProvince(provinceCode) {
      this.formInfo.provinceCode = provinceCode;
      this.queryData();
      this.uiSwitch.isExpand = false;
    },
  },
  

};
</script>

<style lang="less" scoped>
#activity {
  min-height: calc(~"100vh - 395px");
  .activity-banner {
    width: 100%;
  }
  .province-box {
    color: #fff;
    margin-top: 32px;
    .container {
      overflow: hidden;
      background-color: #2f323b;    //这个颜色待修改
      padding: 16px;
      display: flex;
      justify-content: space-between;
      width: 1120px;
      .province-button {
        font-size: 16px;
        flex-shrink: 0;
        font-weight: bold;
        margin-top: 10px;
        cursor: pointer;
        height: 18px;
        display: flex;
        align-items: center;
        i {
          &.arrow-reverse {
            transform: rotate(180deg);
          }
          height: 8px;
          font-size: 12px;
          margin-left: 6px;
        }
      }
      .province-title {
        font-size: 18px;
        padding: 9px 12px 9px 16px;
        height: 36px;
        border: 1px solid #fff;
        line-height: 36px;
        border-radius: 4px;
        text-align: center;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        &::before {
          content: '';
          display: inline-block;
          width: 18px;
          height: 18px;
          background: url(../../assets/imgs/homepage/icon-address.png) no-repeat;
          background-size: 100% 100%;
          margin-right: 5px;
        }
      }
      .province-content {
        &.noauto-height {
          height: 26px;
        }
        height: auto;
        overflow: hidden;
        margin-left: 40px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-top: 10px;
        font-size: 16px;
        .province-item {
          margin-right: 20px;
          margin-bottom: 20px;
          width: 50px;
          cursor: pointer;
          &.chosen {
            opacity: 0.6;
          }
        }
      }
    }
  }

  .no-product {
    padding: 50px 0 100px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .product-box {
    padding: 32px 0;
    .container {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .product-item {
        &:nth-of-type(2n) {
          margin-right: 0;
        }
        cursor: pointer;
        flex-shrink: 0;
        margin-right: 10px;
        width: 495px;
        height: 310px;
        background-color: #ffffff;
        margin-bottom: 10px;
        border-radius: 4px;
        position: relative;
        .product-bg {
          height: 200px;
          // background-position: center center;
          background-size: cover;
          background-repeat: no-repeat;
          border-radius: 4px 4px 0 0;
        }
        .product-off-sell {
          position: absolute;
          top: 0;
          right: 0;
          width: 60px;
          height: 60px;
        }
        .product-country {
          position: absolute;
          left: 10px;
          top: 10px;
          border-radius: 22px;
          width: 66px;
          height: 22px;
          font-size: 16px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.5);
          line-height: 1;
        }
        .product-content{
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 110px;
          padding: 0 16px;
          .product-button {
            height: 50px;
            width: 140px;
            border-radius: 22px;
            background-color: #ff5500;
            color: #ffffff;
            text-align: center;
            line-height: 50px;
            font-size: 24px;
            flex-shrink: 0;
            margin-left: 30px;
          }
          .product-left {
            .product-name {
              font-size: 18px;
              color: #333;
              margin-bottom: 10px;
              width: 295px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical; // 必需要用style写，这里写了其实没用
              overflow: hidden;
              line-height: 24px;
              height: 45px;
            }
            .product-price {
              display: flex;
              align-items: center;
              .price-orange {
                color: #ff5500;
                font-size: 24px;
                margin-right: 8px;
                font-weight: bold;
              }
              .price-special{
                width: 47px;
                height: 20px;
                display: block;
              }
              .price-gray {
                color: #777;
                font-size: 14px;
                margin-left: 8px;
                .del-text{
                  text-decoration: line-through;
                }
              }
            }
          }
        }

      }
    }
  }

}

#promptClose {
  margin: 20px auto;
  background: #ffffff;
  width: 1000px;
  min-height: 595px;
  padding-top: 80px;
  .activityCloseImg {
    width: 150px;
    height: 120px;
    display: block;
    margin: 0 auto;
  }
  .title {
    width: 100%;
    text-align: center;
    font-size: 20px;
    color: #333333;
    margin-top: 30px;
    margin-bottom: 20px;
    font-weight: normal;
    line-height: 20px;
  }
  .content {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    font-size: 14px;
    color: #777777;
    line-height: 14px;
  }
}

#promptNot {
  margin: 20px auto;
  background: #ffffff;
  width: 1000px;
  min-height: 595px;
  padding-top: 80px;
  .activityNotImg {
    width: 150px;
    height: 120px;
    display: block;
    margin: 0 auto;
  }
  .title {
    width: 100%;
    text-align: center;
    font-size: 20px;
    color: #333333;
    margin-top: 30px;
    margin-bottom: 20px;
    font-weight: normal;
    line-height: 20px;
  }
  .content {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    font-size: 14px;
    color: #777777;
    line-height: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activity.vue